import ProductCreationParameters from '../../product-creation-parameters';

export default class WindowstickerCreationParameters
  implements ProductCreationParameters {
  constructor(public type: string) {}
}
